import { Link, useLocation } from "react-router-dom";
import { Phone, Mail, MapPin, Clock, ShieldCheck } from "lucide-react";
import Logo from "@/components/Logo";
import { SITE } from "@/lib/api";

export default function Footer() {
  const { pathname } = useLocation();
  if (pathname.startsWith("/admin")) return null;

  return (
    <footer className="relative border-t border-[#0C2930] bg-[#10333B]" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-5 py-16 sm:px-8">
        <div className="grid gap-12 md:grid-cols-12">
          <div className="md:col-span-5">
            <Logo dark />
            <p className="mt-5 max-w-sm text-sm leading-relaxed text-[#9DBFC7]">
              Corsi pratici di informatica a obiettivo, non a ore. Un metodo esclusivo, insegnanti
              professionisti e la certezza del risultato, in qualunque città, paese o località.
            </p>
          </div>

          <div className="md:col-span-3">
            <h3 className="font-plex text-xs uppercase tracking-[0.24em] text-[#5FC6D6]">Navigazione</h3>
            <ul className="mt-5 space-y-3 text-sm">
              <li><Link data-testid="footer-home" to="/" className="text-[#C9DBDF] transition-colors hover:text-[#7AD9E8]">Home</Link></li>
              <li><Link data-testid="footer-chi-siamo" to="/chi-siamo" className="text-[#C9DBDF] transition-colors hover:text-[#7AD9E8]">Chi Siamo</Link></li>
              <li><Link data-testid="footer-corsi" to="/corsi" className="text-[#C9DBDF] transition-colors hover:text-[#7AD9E8]">I Corsi</Link></li>
              <li><Link data-testid="footer-blog" to="/blog" className="text-[#C9DBDF] transition-colors hover:text-[#7AD9E8]">Blog</Link></li>
              <li><Link data-testid="footer-contatti" to="/contatti" className="text-[#C9DBDF] transition-colors hover:text-[#7AD9E8]">Contatti</Link></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <h3 className="font-plex text-xs uppercase tracking-[0.24em] text-[#5FC6D6]">Contatti</h3>
            <ul className="mt-5 space-y-3.5 text-sm text-[#C9DBDF]">
              <li className="flex items-start gap-3">
                <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-[#5FC6D6]" />
                <span>{SITE.legalName} — {SITE.address}</span>
              </li>
              <li>
                <a href={`tel:${SITE.phone}`} data-testid="footer-phone" className="flex items-center gap-3 transition-colors hover:text-[#7AD9E8]">
                  <Phone className="h-4 w-4 shrink-0 text-[#5FC6D6]" /> {SITE.phoneDisplay}
                </a>
              </li>
              <li>
                <a href={`mailto:${SITE.email}`} data-testid="footer-email" className="flex items-center gap-3 transition-colors hover:text-[#7AD9E8]">
                  <Mail className="h-4 w-4 shrink-0 text-[#5FC6D6]" /> {SITE.email}
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Clock className="h-4 w-4 shrink-0 text-[#5FC6D6]" /> {SITE.hours}
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 flex flex-col gap-4 border-t border-white/10 pt-7 text-xs text-[#7FA8B1] md:flex-row md:items-center md:justify-between">
          <p>
            © {new Date().getFullYear()} {SITE.legalName} — P.IVA / C.F. {SITE.piva}. Tutti i diritti riservati.
          </p>
          <div className="flex flex-wrap items-center gap-x-6 gap-y-2">
            <Link data-testid="footer-cookie-policy" to="/cookie-policy" className="inline-flex items-center gap-1.5 transition-colors hover:text-[#7AD9E8]">
              <ShieldCheck className="h-3.5 w-3.5" /> Cookie Policy
            </Link>
            <Link data-testid="footer-privacy-policy" to="/privacy-policy" className="transition-colors hover:text-[#7AD9E8]">
              Privacy Policy
            </Link>
            <Link data-testid="footer-recesso" to="/recesso" className="transition-colors hover:text-[#7AD9E8]">
              Diritto di Recesso
            </Link>
            <button
              type="button"
              data-testid="footer-cookie-preferences"
              onClick={() => window.dispatchEvent(new CustomEvent("sds-open-cookie-settings"))}
              className="transition-colors hover:text-[#7AD9E8]"
            >
              Preferenze cookie
            </button>
            <Link data-testid="footer-admin" to="/admin" className="transition-colors hover:text-[#7AD9E8]">
              Area Riservata
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
